import DataLayer from './DataLayer';
import Gtm from '@grebban/gtm';
import type { Product } from '@activebrands/core-web/types/tracking-events';

export default ({ currencyCode, product }: {
    currencyCode: string;
    product: Product;
}) => {
    Gtm.addDataLayerEvent('remove_from_cart', {
        event: 'remove_from_cart',
        ecommerce: {
            currencyCode,
            remove: {
                products: [DataLayer.getProduct(product)],
            },
        },
    });
};
